var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "row" } },
    [
      _c(
        "el-form",
        {
          staticStyle: { "margin-right": "15px" },
          attrs: {
            disabled: !_vm.isEditing,
            "label-width": "150px",
            "label-position": "right"
          }
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.notSeaHouseChannelOrWseChannel,
                  expression: "notSeaHouseChannelOrWseChannel"
                }
              ],
              attrs: { label: _vm.$t("Message.Shipper") }
            },
            [
              _c("cargo-company-select", {
                class: _vm.importDifferenceField.shipperId ? "red-border" : "",
                staticStyle: { width: "190px" },
                attrs: {
                  "method-params": { shipper: true, active: true },
                  headers: [_vm.$t("Partners.englishName")],
                  fields: ["englishName"],
                  "tag-name": "englishName",
                  "default-value": _vm.form.shipperId || ""
                },
                on: {
                  change: function(p) {
                    _vm.shipperAutoCompleteChange(p)
                  }
                }
              })
            ],
            1
          ),
          _c("booking-shipper-format-address", {
            ref: "shipperFormatAddress",
            attrs: {
              "country-list": _vm.countryList,
              "manifest-info": _vm.form,
              "is-sea-house-channel": _vm.isSeaHouseChannel,
              "is-wse-channel": _vm.isWseChannel,
              "is-ronge-tong": _vm.isRongeTong,
              "is-editing": _vm.isEditing,
              "show-combined-manifest": _vm.showCombinedManifest,
              "special-character-check": _vm.specialCharacterCheck,
              job: _vm.job
            },
            on: {
              "update:isSeaHouseChannel": function($event) {
                _vm.isSeaHouseChannel = $event
              },
              "update:is-sea-house-channel": function($event) {
                _vm.isSeaHouseChannel = $event
              },
              "update:isWseChannel": function($event) {
                _vm.isWseChannel = $event
              },
              "update:is-wse-channel": function($event) {
                _vm.isWseChannel = $event
              },
              "update:isRongeTong": function($event) {
                _vm.isRongeTong = $event
              },
              "update:is-ronge-tong": function($event) {
                _vm.isRongeTong = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { "margin-right": "15px" },
          attrs: {
            disabled: !_vm.isEditing,
            "label-width": "150px",
            "label-position": "right"
          }
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.notSeaHouseChannelOrWseChannel,
                  expression: "notSeaHouseChannelOrWseChannel"
                }
              ],
              attrs: { label: _vm.$t("Message.Consignee") }
            },
            [
              _c("cargo-company-select", {
                class: _vm.importDifferenceField.consigneeId
                  ? "red-border"
                  : "",
                staticStyle: { width: "190px" },
                attrs: {
                  "method-params": { consignee: true, active: true },
                  headers: [_vm.$t("Partners.englishName")],
                  fields: ["englishName"],
                  "tag-name": "englishName",
                  "default-value": _vm.form.consigneeId || ""
                },
                on: {
                  change: function(p) {
                    _vm.consigneeAutoCompleteChange(p)
                  }
                }
              })
            ],
            1
          ),
          _c("booking-consignee-format-address", {
            ref: "consigneeFormatAddress",
            attrs: {
              "country-list": _vm.countryList,
              "manifest-info": _vm.form,
              "is-sea-house-channel": _vm.isSeaHouseChannel,
              "is-wse-channel": _vm.isWseChannel,
              "is-ronge-tong": _vm.isRongeTong,
              "is-editing": _vm.isEditing,
              "show-combined-manifest": _vm.showCombinedManifest,
              "special-character-check": _vm.specialCharacterCheck,
              job: _vm.job
            },
            on: {
              "update:isSeaHouseChannel": function($event) {
                _vm.isSeaHouseChannel = $event
              },
              "update:is-sea-house-channel": function($event) {
                _vm.isSeaHouseChannel = $event
              },
              "update:isWseChannel": function($event) {
                _vm.isWseChannel = $event
              },
              "update:is-wse-channel": function($event) {
                _vm.isWseChannel = $event
              },
              "update:isRongeTong": function($event) {
                _vm.isRongeTong = $event
              },
              "update:is-ronge-tong": function($event) {
                _vm.isRongeTong = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { "margin-right": "15px" },
          attrs: {
            disabled: !_vm.isEditing,
            "label-width": "150px",
            "label-position": "right"
          }
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.notSeaHouseChannelOrWseChannel,
                  expression: "notSeaHouseChannelOrWseChannel"
                }
              ],
              attrs: { label: _vm.$t("Message.Notify") }
            },
            [
              _c("cargo-company-select", {
                class: _vm.importDifferenceField.notifyId ? "red-border" : "",
                staticStyle: { width: "190px" },
                attrs: {
                  "method-params": { notify: true, active: true },
                  headers: [_vm.$t("Partners.englishName")],
                  fields: ["englishName"],
                  "tag-name": "englishName",
                  "default-value": _vm.form.notifyId || ""
                },
                on: {
                  change: function(p) {
                    _vm.notifyAutoCompleteChange(p)
                  }
                }
              })
            ],
            1
          ),
          _c("booking-notify-format-address", {
            ref: "notifyFormatAddress",
            attrs: {
              "country-list": _vm.countryList,
              "manifest-info": _vm.form,
              "is-sea-house-channel": _vm.isSeaHouseChannel,
              "is-wse-channel": _vm.isWseChannel,
              "is-ronge-tong": _vm.isRongeTong,
              "is-editing": _vm.isEditing,
              "show-combined-manifest": _vm.showCombinedManifest,
              "special-character-check": _vm.specialCharacterCheck,
              job: _vm.job
            },
            on: {
              "update:isSeaHouseChannel": function($event) {
                _vm.isSeaHouseChannel = $event
              },
              "update:is-sea-house-channel": function($event) {
                _vm.isSeaHouseChannel = $event
              },
              "update:isWseChannel": function($event) {
                _vm.isWseChannel = $event
              },
              "update:is-wse-channel": function($event) {
                _vm.isWseChannel = $event
              },
              "update:isRongeTong": function($event) {
                _vm.isRongeTong = $event
              },
              "update:is-ronge-tong": function($event) {
                _vm.isRongeTong = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section form-column", staticStyle: { width: "520px" } },
        [
          !_vm.isAddSpelling
            ? _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-options": _vm.edi.gridOptions,
                          "column-defs": _vm.edi.columnDefs,
                          "row-data": _vm.ediFinalRowData,
                          "show-side-bar": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.edi.gridApi = params.api
                          }
                        }
                      }),
                      _c(
                        "div",
                        { staticStyle: { padding: "15px 0" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", disabled: _vm.isEdit },
                              on: { click: _vm.onCount }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.isEditing
                              },
                              on: { click: _vm.ediAdd }
                            },
                            [_vm._v(_vm._s(_vm.$t("Payment.new")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  !(
                                    _vm.isEditing &&
                                    _vm.ediFinalRowData.length > 1
                                  ) ||
                                  (Boolean(_vm.form.manifestId) &&
                                    _vm.isSeaHouseChannel),
                                type: "danger"
                              },
                              on: { click: _vm.ediRemove }
                            },
                            [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", disabled: _vm.isEdit },
                              on: { click: _vm.ediValid }
                            },
                            [_vm._v(_vm._s(_vm.$t("Payment.invalid")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.edi.countVisible
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.TotalCustomsNo"))
                                )
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.TotalNumberOfPieces")
                                  )
                                )
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.TotalGrossWeight"))
                                )
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.TotalVolume")))
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(" " + _vm._s(_vm.edi.btnSumSoNo) + "个 ")
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(_vm._s(_vm.edi.btnSumQty))
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(_vm._s(_vm.edi.btnSumWeight))
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(_vm._s(_vm.edi.btnSumCubage))
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CustomsNoNotImported")
                                  )
                                )
                              ]),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      readonly: true,
                                      disabled: true,
                                      type: "textarea",
                                      rows: 7
                                    },
                                    model: {
                                      value: _vm.edi.noExcelSoNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.edi, "noExcelSoNo", $$v)
                                      },
                                      expression: "edi.noExcelSoNo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.isAddSpelling
        ? _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { staticClass: "label-none custom" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "224px", height: "200px" },
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.finalRowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  }),
                  _c("div", { staticStyle: { padding: "5px 0" } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.isEditing
                            },
                            on: { click: _vm.add }
                          },
                          [_vm._v(_vm._s(_vm.$t("Payment.new")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !(
                                _vm.isEditing && _vm.finalRowData.length > 1
                              ),
                              type: "danger"
                            },
                            on: { click: _vm.remove }
                          },
                          [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }